"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Researchgate = function Researchgate(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M7.843,13.76c-0.461,0.005-0.921-0.013-1.38-0.052V8.64c0.263-0.018,0.581-0.027,0.981-0.03 l0.591-0.002c1.724,0,2.695,0.889,2.695,2.49c0,1.622-1.102,2.661-2.886,2.661H7.843z M21.001,0h-18c-1.657,0-3,1.343-3,3v18 c0,1.657,1.343,3,3,3h18c1.657,0,3-1.343,3-3V3C24.001,1.343,22.658,0,21.001,0z M15.151,20.831l-0.089,0.135 c-0.252,0.115-0.653,0.184-1.038,0.184c-1.23,0-2.266-0.474-2.959-1.308c-0.825-0.951-2.051-2.769-3.204-4.824 c-0.664,0-0.912-0.005-1.233-0.021l-0.162-0.012v3.394c0,1.143,0.184,1.451,0.741,1.535l1.104,0.15l0.13,0.15v0.617l-0.156,0.15 c-0.904-0.037-1.808-0.058-2.712-0.063c-0.573,0-1.169,0.015-1.865,0.038L3.01,20.982l-0.154-0.15v-0.618l0.123-0.147l0.806-0.15 c0.564-0.107,0.75-0.409,0.75-1.533V9.99c0-1.124-0.186-1.427-0.747-1.534L2.98,8.305L2.851,8.16V7.542l0.156-0.15 C4.238,7.427,5.47,7.423,6.7,7.381C7.441,7.359,7.885,7.35,8.418,7.35c2.683,0,4.419,1.305,4.419,3.642 c0,1.65-1.251,3.25-2.919,3.737c0.921,1.606,2.078,3.184,3.112,4.317c0.614,0.663,1.329,1.08,1.971,1.08l0.15,0.15V20.831z  M20.392,7.086c0,0.454-0.008,0.67-0.034,0.91C20.335,8.24,20.29,8.48,20.223,8.715c-0.186,0.576-0.483,0.99-0.935,1.299 c-0.45,0.307-1.027,0.473-1.65,0.473c-0.638,0-1.181-0.147-1.626-0.443c-0.448-0.297-0.769-0.74-0.96-1.32 c-0.038-0.112-0.068-0.227-0.09-0.344c-0.055-0.315-0.087-0.633-0.096-0.953c-0.016-0.505-0.016-1.01,0-1.515 c0.011-0.319,0.043-0.638,0.098-0.952c0.022-0.119,0.051-0.233,0.089-0.344c0.192-0.581,0.513-1.023,0.961-1.32 c0.445-0.297,0.99-0.444,1.628-0.444c0.328,0,0.625,0.039,0.892,0.116c0.266,0.078,0.504,0.184,0.713,0.322s0.387,0.297,0.537,0.48 c0.148,0.18,0.27,0.375,0.362,0.571c0.073,0.13,0.045,0.27-0.105,0.36l-0.76,0.311c-0.14,0.078-0.282,0.027-0.351-0.111 c-0.186-0.341-0.318-0.505-0.516-0.63c-0.229-0.147-0.499-0.218-0.771-0.203c-0.345,0-0.504,0.053-0.759,0.233 c-0.237,0.161-0.413,0.399-0.496,0.673c-0.056,0.171-0.09,0.348-0.102,0.528c-0.047,0.779-0.047,1.561,0,2.34 c0.012,0.18,0.046,0.357,0.102,0.528c0.065,0.248,0.222,0.462,0.438,0.6c0.241,0.163,0.527,0.245,0.818,0.235 c0.292,0.008,0.579-0.073,0.825-0.231c0.201-0.136,0.349-0.337,0.418-0.57l0.042-0.146c0.026-0.093,0.047-0.188,0.062-0.284 c0.021-0.13,0.026-0.24,0.026-0.529H17.86l-0.003-0.005c-0.153,0-0.255-0.102-0.255-0.255V6.48c0-0.151,0.102-0.255,0.255-0.255 h2.28c0.151,0,0.255,0.104,0.255,0.255V7.086z"
  }));
};

Researchgate.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Researchgate.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Researchgate;
exports.default = _default;